import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ktRequest from '../utils/request';
import queryString from 'query-string';

class LaunchPdfExport extends Component {
  async componentDidMount () {
    const qsValues = queryString.parse(this.props.location.search);
    const centerId = qsValues.centerId;
    const start = qsValues.start;

    const pdfData = await ktRequest.get(`pdf/scheduling-weekly?centerId=${centerId}&offset=${(new Date()).getTimezoneOffset()}&start=${start}`, 'timecards');

    console.log(pdfData.pdf);

    const newWin = window.open('');
    newWin.document.body.innerHTML = `<embed src="data:application/pdf;base64, ${pdfData.pdf}" width="100%" height="100%">`;
    window.close();
  }

  render () {
    return (
      <Fragment />
    );
  }
}

export default connect(
)(LaunchPdfExport);
